"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactJss = require("react-jss");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var isThemeColor = function isThemeColor(color, colors) {
  return color in colors;
};
var useColor = function useColor(color) {
  var theme = (0, _reactJss.useTheme)();
  if (!color) {
    return color;
  }
  return isThemeColor(color, theme.colors) ? theme.colors[color] : color;
};
var _default = exports.default = useColor;